import { Typography } from 'antd';
import { ContainerIcon, ContainerText, ContainerTitle } from './styles';
import { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon';
const { Title } = Typography;

interface ITitleProps {
  children: React.ReactNode;
  icon?: AntdIconProps | any;
  level?: any;
  color?: string;
}

export const ATitle: React.FC<ITitleProps> = ({
  icon,
  level,
  color,
  children,
}) => {
  return (
    <ContainerTitle>
      {icon && <ContainerIcon>{icon}</ContainerIcon>}
      <ContainerText>
        <Title level={level ?? 3} style={{ margin: 0, color }}>
          {children}
        </Title>
      </ContainerText>
    </ContainerTitle>
  );
};
